<template>
  <div class="bb-table-balance">
    <div class="bb-table-balance-header">
      <div class="bb-table-balance-header__item">DESCRIPTION</div>
      <div class="bb-table-balance-header__item"></div>
      <div class="bb-table-balance-header__item bb-table-balance-header__item_end">Invoiced, AED</div>
      <div class="bb-table-balance-header__item
                  bb-table-balance-header__item_color
                  bb-table-balance-header__item_center"
      >
        Received, AED
      </div>
      <div class="bb-table-balance-header__item
                  bb-table-balance-header__item_color
                  bb-table-balance-header__item_center"
      >
        Paid, AED
      </div>
      <div class="bb-table-balance-header__item bb-table-balance-header__item_end">BALANCE, AED</div>
    </div>
    <div class="bb-table-balance-body">
      <div v-for="(row, index) in rows"
           :key="row._id"
           class="bb-table-balance-row"
           :class="{
             'bb-table-balance-row-height': row.$accordionContent,
             'bb-table-balance-row_border': !includeCategory(row)
           }"
      >
        <div class="bb-table-balance-row__item">
          <span class="bb-table-balance__number">{{index + 1}}</span>
          <span v-if="includeCategory(row)">
            <b>{{getNameCategory(row)}}</b>
          </span>
          <span v-html="row.name">
            {{row.name}}
          </span>
          <span class="bb-table-balance-type"
                v-if="row.isCreditNote || row.isShortfall"
          >
            {{row.isCreditNote ? 'Credit note' : 'Shortfall'}}
          </span>
        </div>
        <AccordionButton :list="row.soas" :row="row"/>
        <div class="bb-table-balance-row__item
                    bb-table-balance-row__item_end"
             :class="{'bb-table-balance-row__item_height-invoice': getSoas(row)}"
        >
          {{getInvoiced(row)}}
        </div>
        <div class="bb-table-balance-row__item
                    bb-table-balance-row__item_end
                    bb-table-balance-row__item_color"
             :class="{
          'bb-table-balance-row__item_height-received': getSoas(row)
        }"
        >
          {{getReceived(row)}}
        </div>
        <div class="bb-table-balance-row__item
                    bb-table-balance-row__item_end
                    bb-table-balance-row__item_color"
             :class="{
          'bb-table-balance-row__item_height-paid': getSoas(row)
        }"
        >
          {{getPaid(row)}}
        </div>
        <div class="bb-table-balance-row__item
                    bb-table-balance-row__item_end"
             :class="{'bb-table-balance-row__item_height_balance': getSoas(row)}"
        >
          {{getBalance(row)}}
        </div>
        <div class="bb-table-balance-row__item bb-table-balance-soa__list">
          <SoaBalance :row="row"
                      @openProforma="openProforma"
                      @openBalanceLink="openBalanceLink"
          />
        </div>
        <div v-if="includeSoas(row)"
             class="bb-table-balance-row__item bb-table-balance-soa bb-table-balance-soa_color"
        >
          <div class="bb-table-balance-table-soa" v-for="soa in row.soas" :key="soa._id">
            <div class="bb-table-balance-table-soa__item">{{formatDate(soa.date)}}</div>
            <div class="bb-table-balance-table-soa__item">{{soa.description}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {find, get} from 'lodash'
import moment from 'moment'
import convertNumber from '@/mixin/convertNumber'
import Plus from '@/components/Main/Icons/Plus'
import Minus from '@/components/Main/Icons/Minus'
import SoaBalance from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableBalance/SoaBalance'
import AccordionBalance
  from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableBalance/AccordionBalance'
import AccordionButton from '@/components/Main/AccordionButton/AccordionButton'
import serviceCategoriesList from '@/mixin/serviceCategoriesList'

export default {
  name: 'TableBalance',
  props: ['rows'],
  components: {
    Plus,
    Minus,
    AccordionBalance,
    AccordionButton,
    SoaBalance
  },
  mixins: [convertNumber, serviceCategoriesList],
  computed: {
    serviceCategories: {
      get: function () {
        return this.$store.getters.serviceCategories
      },
      set: function (data) {
        this.$store.dispatch('setServiceCategories', data)
      }
    }
  },
  data () {
    return {
      openContent: false
    }
  },
  methods: {
    getInvoiced (row) {
      const value = get(row, 'invoiced', 0)
      return this.convertNumber(value)
    },
    getReceived (row) {
      const value = get(row, 'received', 0)
      return this.convertNumber(value)
    },
    formatDate (date) {
      return moment(date).format('DD-MMM-YYYY')
    },
    getPaid (row) {
      const value = get(row, 'paid', 0)
      return this.convertNumber(value)
    },
    includeCategory (row) {
      return typeof row.category === 'number'
    },
    getSoas (row) {
      const value = get(row, 'soas', [])
      return value.length === 1
    },
    openProforma (event, soa) {
      this.$emit('openProforma', event, soa)
    },
    openBalanceLink (soa) {
      this.$emit('openBalanceLink', soa)
    },
    getNameCategory (row) {
      const category = get(row, 'category', 0)
      this.serviceCategories = this.serviceCategoriesList
      const res = find(this.serviceCategories, item => item.id === category)
      return res ? res.name : ''
    },
    getBalance (row) {
      const value = get(row, 'balance', 0)
      return this.convertNumber(value)
    },
    setOpen (val) {
      this.openContent = val
    },
    includeSoas (row) {
      const soas = get(row, 'soas', [])
      return !!(soas.length && soas.length === 1)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../sass/variables";
  @import "../../../../../../../sass/mixins";

  .bb-table-balance {
    @include global-font;

    &-header {
      position: relative;
      display: grid;
      width: 100%;
      grid-template-columns: minmax(307px, 502px) minmax(17px, 76px) repeat(4, minmax(61px, 152px));
      padding-bottom: 19px;

      &__item {
        font-weight: 600;
        font-size: 12px;
        line-height: 14px;
        text-transform: uppercase;
        color: $color-denim;
        padding-top: 10px;

        &_color {
          background-color: $color-link-water;
          position: relative;
          left: 46px;
          padding-top: 10px;
          padding-left: 15px;
          height: calc(100% + 20px);
        }

        &_center {
          text-align: center;
        }

        &_end {
          text-align: end;
        }
      }
    }

    &-row {
      position: relative;
      display: grid;
      align-items: center;
      border-top: 1px solid $color-wild-sand;
      padding: 18px 0;
      grid-template-columns: minmax(307px, 502px) minmax(17px, 76px) repeat(4, minmax(61px, 152px));

      &_border {
        border-top: 1px solid $color-silver;
      }

      &:first-child {
        border-top: none;
      }

      &__item {
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;

        &_center {
          text-align: center;
          margin-left: 25px;
        }

        &_end {
          text-align: end;
        }

        &_color {
          position: relative;
          left: 30%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-left: 16px;
          background-color: $color-link-water;
          margin: -18px 0;
          height: calc(100% + 36px);
        }

        &_height-invoice {
          grid-column: 3;
          grid-row: 1/ span 3;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          height: calc(100% + 36px);
        }

        &_height_balance {
          grid-column: 6;
          grid-row: 1/ span 3;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          height: calc(100% + 36px);
        }

        &_height-received{
          background-color: $color-link-water;
          grid-column: 4;
          grid-row: 1/ span 3;
          display: flex;
          align-items: center;
          justify-content: center;
          height: calc(100% + 36px);
        }

        &_height-paid {
          background-color: $color-link-water;
          grid-column: 5;
          grid-row: 1/ span 3;
          display: flex;
          align-items: center;
          justify-content: center;
          height: calc(100% + 36px);
        }

        &_right {
          padding-right: 4px;
        }
      }
    }

    &__number {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      background: rgba($color-accent, 0.15);
      padding: 2px 6px;
      font-weight: bold;
      font-size: 11px;
      line-height: 13px;
      color: $color-accent;
      border-radius: 50%;
      margin-right: 8px;
    }

    &-type {
      position: relative;
      white-space: nowrap;
      padding: 3px 4px;
      background: rgba($color-accent, 0.2);
      border-radius: 2px;
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      text-align: center;
      color: $color-accent;
      margin-left: 15px;
    }

    &-table-soa {
      display: grid;
      align-items: center;
      grid-template-columns: minmax(83px, 116px) minmax(264px, 200px);

      &__item {
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;
        text-transform: capitalize;

        &_center {
          text-align: center;
          margin-left: 10px;
        }

        &_end {
          text-align: end;
        }
      }
    }

    &-control {
      position: relative;
      width: 18px;
      height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      box-sizing: border-box;
      border: 1px solid rgba($color-silver, 0.3);
      color: $color-accent;
      transition: 0.3s;
      cursor: pointer;

      &:hover {
        color: $color-accent-hover;
        border-color: rgba($color-silver, 0.6);
      }

      &__icon {
        position: absolute;
        top: auto;
        left: auto;
        width: 10px;
        height: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0;
        transition: 0.2s;

        &:before {
          margin: 0;
        }
      }
    }

    &-soa {
      grid-column: 1/3;

      &__list {
        grid-row: 2;
        grid-column: 1/7;
      }

      &_color {
        background-color: transparent;
        margin: 13px -16px 0 15px;
        padding: 9px 16px;
      }
    }
  }
</style>
<style lang="scss">
  @import "../../../../../../../sass/variables";
  @import "../../../../../../../sass/mixins";

  .bb-table-balance {
    b {
      font-weight: bold;
      font-size: 14px;
      line-height: 17px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableBalance/TableBalance.vue